export enum PaymentType {
  Rent = "rent",
  Insurance = "insurance",
  Discount = "discount",
  Rounding = "rounding",
  Total = "total",
}
